// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"120":"ecaf186e64364af1","494":"feef8fce91fbd6e2","856":"917da4ebb4ab99f8"}[chunkId] + "";
};